export const EXPERIMENTS = {
    SPIDERS_CONTEXTUAL_IDENTIFICATION_FLOW: 4249,
} as const;
export const ROLLOUTS = {
    SPIDERS_LOCALIZATION: 'spiders_localization',
    SPIDERS_CONTEXTUAL_IDENTIFICATION_FLOW: 'spiders_contextual_identification_flow',
} as const;
